<template>
  	<div class="row">
		<SideMenu/>
		<div class="right-column">
			<TopBar/>
			<main class="main-content p-5" role="main">
				<div class="row">
					<div class="col-md-12">
						<h1> {{title}} </h1>
					</div>
				</div>

				<div class="row">
					<div class="col-md-8 mb-5">
						<div class="card mb-5">
							<div class="card-header">
								Detalle de la Orden
							</div>
							<div class="card-body">
								<form>
									<div class="form-row mb-2">
										<div class="form-group col-md-6">
											<label for="folio">Folio</label>
											<input type="text" class="form-control" id="folio" placeholder="Folio" v-model="orden.folio" readonly>
										</div>
										<div class="form-group col-md-6">
											<label for="estatus">Estatus</label>
											<input type="text" class="form-control text-capitalize" id="estatus" placeholder="Estatus" readonly v-model="orden.status">
										</div>
									</div>
									<div class="form-row">
										<div class="form-group col-md-6">
											<label for="consumo">Consumo</label>
											<input type="text" class="form-control text-capitalize" id="conusmo" placeholder="Consumo" v-model="orden.consumo" readonly>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
					<div class="col-md-4 mb-5">
						<div class="card">
							<div class="card-header">
								Opciones
							</div>
							<div class="card-body">								
								<button type="button" class="btn btn-success p-2 btn-block mb-2" @click="save"> <i class="fa fa-floppy-o mr-2"></i> Guardar </button>
								<button type="button" class="btn btn-danger p-2 btn-block mb-2" @click="delet"> <i class="fa fa-times mr-2"></i> Cancelar </button>
								<button type="button" class="btn btn-secondary p-2 btn-block mb-2" @click="goBack"> <i class="fa fa-arrow-left mr-2"></i> Salir </button>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6 mb-5">
						<div class="card">
							<div class="card-header">
								Pedido
							</div>
							<div class="card-body">
								<div class ="row">
									<div class="col-lg-12">
										<div class="table-responsive mb-2">
											<table class="table">
												<thead>
													<tr>
														<th width="15px">#</th>
														<th>Platillo</th>
														<th width="75px">Cantidad</th>
														<th width="110px">Detalles</th>
														<th width="50px">Precio</th>
														<th width="35px">Editar</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(rEspecial, idx) in nonDeleted" v-bind:key="idx" >
														<th scope="row" style="vertical-align: middle;"> {{idx + 1 }}  </th>
														<td style="vertical-align: middle;"> 
															<div class="form-group">                                                        
																<select class="form-control" v-model="rEspecial.alimentoId" style="height: 34.32px; border-radius: 5px;">
																<option v-for="rAlimento in lAlimentos" v-bind:value="rAlimento.alimentoId" v-bind:key="rAlimento.alimentoId" >
																	{{rAlimento.nombre}}
																</option>
																</select>
															</div>
														</td>
														<td style="vertical-align: middle;">
															<input v-model="rEspecial.cantidad" type="text" class="form-control" placeholder=""  style="width:100%">
														</td>
														<td style="vertical-align: middle;">
															<input type="text" class="form-control" placeholder="Anotaciones..." style="height:34.32px; margin:0px; width:100%" v-model="rEspecial.detalles">
														</td>
														<td style="vertical-align: middle;">
															$ {{getPrecio(rEspecial.alimentoId)*rEspecial.cantidad}}
														</td>
														<td style="vertical-align: middle;">
															<button type="button" class="btn btn-secondary btn-sm waves-effect waves-light" style="height:34.32px; margin:0px; width:100%" @click="removePlato(rEspecial.platoId)" > <i class="fa fa-trash"/> </button>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-6 mb-5">
						<div class="card mb-5 mh-75">
							<div class="card-header">
								Detalle del Cobro
							</div>
							<div class="card-body">
								<div class="form-row mb-2" v-if="orden.consumo == 'domicilio'">
									<div class="form-group col-md-12">
										<label for="estatus">Subtotal</label>
										<input type="number" class="form-control" id="estatus" placeholder="Subtotal" readonly :value="getTotal(1)">
									</div>
									<div class="form-group col-md-12">
										<label for="estatus">Cobro envio</label>
										<input type="number" class="form-control" id="estatus" placeholder="Estatus" readonly v-model="orden.cobroEnvio">
									</div>
									<div class="form-group col-md-12">
										<label for="estatus">Total</label>
										<input type="number" class="form-control" id="estatus" placeholder="Estatus" readonly :value="getTotal(0)">
									</div>
								</div>
								<div class="form-row mb-2" v-else>
									<div class="form-group col-md-12">
										<label for="estatus">Total</label>
										<input type="number" class="form-control" id="estatus" placeholder="Estatus" readonly :value="getTotal(0)">
									</div>
								</div>
								<p v-if="orden.status == 'abierta'"> ** La orden aun no ha sido cobrada</p>
							</div>
						</div>
					</div>
				</div>
			</main>
		</div>
	</div>
</template>


<script>
import SideMenu from '@/components/SideMenu.vue';
import TopBar from '@/components/TopBar.vue';
import ResOrdenes from '@/modules/restaurant/models/ResOrdenes.js';
import OrderList from '@/components/Restaurant/Heris/Order/List.vue';
import ResAlimentos from '@/modules/restaurant/models/ResAlimentos.js';

// import Faker from 'faker';

export default {
  name: 'viewHistorialEdit',
  props: ["item"],
  mounted() {
	  const _this = this
	  ResOrdenes.init(_this.item.ordenId, _this.loadItem)
	  ResAlimentos.list(150, {}, function(res){
		console.log('resalimentos', res);
		_this.lAlimentos = res.data.items;  
	  });
  },
  data() {
    return {
		title: "Editar Orden",
		debug: process.env.VUE_APP_DEV,
		orden: null,
		lAlimentos: [],
		item: null,
      };
  },
  components: {
	  SideMenu,
	  TopBar,
	  OrderList
  },
  methods: {
	loadItem(res){
		console.log(res)
		this.orden = res.data.item
	},
	save(){
		let _this = this;
		ResOrdenes.save(this.orden, function(res){
			console.log('res orden', res);
			_this.$toast.success('Orden Actualizada');
		})
	},
	delet(){
		let _this = this;
		ResOrdenes.delete(this.orden.ordenId, function(res){
			_this.$toast.success('Orden Eliminada');
			_this.goBack()
		});
	},
	goBack(){
		this.$router.push({ name: 'ResOrdenesHistorial', params: {auth: true}})
	},
	getPrecio(id){
		var precio
		this.lAlimentos.forEach(element => {
			if(element.alimentoId == id){
				precio = element.precio
			}
		})
		return precio
	},
	getTotal(type){
		var Total = 0; 
		this.orden.resPlatos.forEach(element => {
			var precio = this.getPrecio(element.alimentoId)
			var cantidad = element.cantidad

			Total = Total+(precio*cantidad)
		})

		if(type == 1){
			return Total
		}

		if(this.orden.consumo == "domicilio"){
			Total += this.orden.cobroEnvio
		}
		return Total
	},
	removePlato(idx){
		var plato = this.orden.resPlatos.find(plato => plato.platoId === idx);
		plato.cantidad = 0;
	},
  },
  computed: {
	  nonDeleted(){
		var platos = this.orden.resPlatos;
		platos = platos.filter(function(plato) {
			return plato.cantidad > 0;
		});
		return platos
	  }
  }
};
</script>

<style>

</style>